import React, { useState } from "react";
import "./BankTransfer15to25.css";
import {
  handleTransferApi,
  handleTransferApi15to16,
  handleTransferApi15to17,
  handleTransferApi15to18,
  handleTransferApi16to19,
  handleTransferApi16to20,
  handleTransferApi17to21,
  handleTransferApi17to22,
  handleTransferApi18to23,
  handleTransferApi18to24,
  handleTransferApi25to16,
  markFraud,
  handleReleaseButton,
} from "./services/apinew"; // Import the API function
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useEffect } from "react";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa"; // Import the required icons
import { fetchCount, fetchTimeTaken } from "./services/apinew";
import { handleTruncateApi, handleInsertApi } from "./services/apinew";
import Panic from "./panic.png";
import { useNavigate } from "react-router-dom";

const BankTransfer15to25 = () => {
  const [amount, setAmount] = useState("1,000"); // Prefill amount with 1000
  const [tag15, setTag15] = useState(""); // State to hold tag5 from response
  const [tag4, setTag4] = useState("");
  const [amountTransferred15, setAmountTransferred15] = useState(""); // State for amountTransferred5
  const [amountTransferred16, setAmountTransferred16] = useState(""); // State for amountTransferred5
  const [amountTransferred17, setAmountTransferred17] = useState(""); // State for amountTransferred5
  const [amountTransferred18, setAmountTransferred18] = useState(""); // State for amountTransferred5
  const [amountTransferred19, setAmountTransferred19] = useState(""); // State for amountTransferred5
  const [amountTransferred20, setAmountTransferred20] = useState(""); // State for amountTransferred5
  const [amountTransferred21, setAmountTransferred21] = useState(""); // State for amountTransferred5
  const [amountTransferred22, setAmountTransferred22] = useState(""); // State for amountTransferred5
  const [amountTransferred23, setAmountTransferred23] = useState(""); // State for amountTransferred5
  const [amountTransferred24, setAmountTransferred24] = useState(""); // State for amountTransferred5
  const [amountTransferred25, setAmountTransferred25] = useState(""); // State for amountTransferred5
  const [isTransactionSuccessful, setIsTransactionSuccessful] = useState(false);
  const [amount1, setAmount1] = useState("1,00,000"); // Prefill amount with 1000
  const [amount2, setAmount2] = useState("50,000"); // Prefill amount with 1000
  const [amount3, setAmount3] = useState("30,000"); // Prefill amount with 1000
  const [amount4, setAmount4] = useState("25,000"); // Prefill amount with 1000
  const [amount5, setAmount5] = useState("25,000"); // Prefill amount with 1000
  const [amount6, setAmount6] = useState("30,000"); // Prefill amount with 1000
  const [amount7, setAmount7] = useState("25,000"); // Prefill amount with 1000
  const [amount8, setAmount8] = useState("20,000"); // Prefill amount with 1000
  const [amount9, setAmount9] = useState("10,000"); // Prefill amount with 1000
  const [amount25, setAmount25] = useState("50,000"); // Prefill amount with 1000
  const [amount10, setAmount10] = useState("1,000"); // Prefill amount with 1000
  const [amount11, setAmount11] = useState("1,000"); // Prefill amount with 1000
  const [amount12, setAmount12] = useState("1,000"); // Prefill amount with 1000
  const [amount13, setAmount13] = useState("1,000"); // Prefill amount with 1000
  const [amount14, setAmount14] = useState("1,000"); // Prefill amount with 1000
  const [amount15, setAmount15] = useState("1,000"); // Prefill amount with 1000
  const [tag16, setTag16] = useState(""); // State to show API response
  const [tag17, setTag17] = useState(""); // State to show API response
  const [isTransactionSuccessful15, setIsTransactionSuccessful15] =
    useState(false); // State for Bank 5 Transaction Success
  const [isTransactionSuccessful15to17, setIsTransactionSuccessful15to17] =
    useState(false);
  const [isTransactionSuccessful15to18, setIsTransactionSuccessful15to18] =
    useState(false);
  const [isTransactionSuccessful16to19, setIsTransactionSuccessful16to19] =
    useState(false);
  const [isTransactionSuccessful16to20, setIsTransactionSuccessful16to20] =
    useState(false);
  const [isTransactionSuccessful17to21, setIsTransactionSuccessful17to21] =
    useState(false);
  const [isTransactionSuccessful17to22, setIsTransactionSuccessful17to22] =
    useState(false);
  const [isTransactionSuccessful18to23, setIsTransactionSuccessful18to23] =
    useState(false);
  const [isTransactionSuccessful18to24, setIsTransactionSuccessful18to24] =
    useState(false);
  const [isTransactionSuccessful25to16, setIsTransactionSuccessful25to16] =
    useState(false);
  const [tag18, setTag18] = useState(""); // State to show API response
  const [tag19, setTag19] = useState(""); // State to show API response
  const [tag20, setTag20] = useState(""); // State to show API response
  const [tag21, setTag21] = useState(""); // State to show API response
  const [tag22, setTag22] = useState(""); // State to show API response
  const [tag23, setTag23] = useState(""); // State to show API response
  const [tag24, setTag24] = useState(""); // State to show API response
  const [tag25, setTag25] = useState(""); // State to show API response
  const [panicMessage, setPanicMessage] = useState("");
  const [count, setCount] = useState(null);
  const [timeDifference, setTimeDifference] = useState(null);
  const [status, setStatus] = useState(null);
  const [status1, setStatus1] = useState(null);
  const [loading, setLoading] = useState(false); // Loader state for Truncate API
  const [loading1, setLoading1] = useState(false); // Loader state for Insert API
  const [connectedTag20, setConnectedTag20] = useState(""); // State to show API response
  const [connectedTag21, setConnectedTag21] = useState(""); // State to show API response
  const [connectedTag22, setConnectedTag22] = useState(""); // State to show API response
  const [connectedTag23, setConnectedTag23] = useState(""); // State to show API response
  const [connectedTag24, setConnectedTag24] = useState(""); // State to show API response
  const [connectedTag15, setConnectedTag15] = useState(""); // State to show API response
  const [connectedTag16, setConnectedTag16] = useState(""); // State to show API response
  const [connectedTag25, setConnectedTag25] = useState(""); // State to show API response
  const [connectedTag19, setConnectedTag19] = useState(""); // State to show API response
  const [selectedOption, setSelectedOption] = useState("");
  const [releaseMessages, setReleaseMessages] = useState({});
  const [updatedConnectedTags, setUpdatedConnectedTags] = useState({});
  const [tagvalidity, setTagValidity] = useState(0); // Initialize with 0
  const [allReleasedTags, setAllReleasedTags] = useState({});


  useEffect(() => {
    document.title = "TAGER AI-Bank15to25"; // Set the page title for this route
  }, []);

  // Fetch the data when the component is mounted and periodically after every interval
  useEffect(() => {
    const fetchCountData = async () => {
      try {
        const count = await fetchCount();
        setCount(count);
        // Re-fetch after the first response
        setTimeout(fetchCountData, 1000);
      } catch (error) {
        console.error("Error fetching count:", error);
      }
    };

    fetchCountData();
  }, []);

  useEffect(() => {
    const fetchTimeTakenData = async () => {
      try {
        const timeDifference = await fetchTimeTaken();
        setTimeDifference(timeDifference);
        // Re-fetch after the first response
        setTimeout(fetchTimeTakenData, 1000);
      } catch (error) {
        console.error("Error fetching time taken:", error);
      }
    };

    fetchTimeTakenData();
  }, []);
  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleReleaseButtonClick = async () => {
    const input = selectedOption;
    const result = await handleReleaseButton(input);
    console.log("API result:", result);

    const messages = {};
    const updatedTags = {};

    if (result && Array.isArray(result) && result.length > 0) {
      result.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key.startsWith("updatedConnectedTag") && item[key]) {
            const tagKey = key.replace("updatedConnectedTag", "connectedTag");

            const shouldSkip =
              (input === "1B15B16-1B15B16-0" && tagKey === "connectedTag16") ||
              (input === "1B25B16-1B25B16-0" &&
                ["connectedTag19", "connectedTag20", "connectedTag25"].includes(tagKey));

            if (!shouldSkip) {
              updatedTags[tagKey] = item[key];

              const tagsArray = item[key].split(",");
              tagsArray.forEach((tag) => {
                if (["1B15B16(I)", "1B25B16(I)"].includes(tag.trim())) {
                  messages[tagKey] = "Tag Released";
                }
              });
            }
          }
        });
      });
    }

    // Force release logic for 1B15B16
    if (input === "1B15B16-1B15B16-0") {
      if (tag19 && tag19.includes("B15B16")) {
        updatedTags.connectedTag19 = "1B15B16(I)";
        messages.connectedTag19 = "Tag Released";
      }
      if (tag20 && tag20.includes("B15B16")) {
        updatedTags.connectedTag20 = "1B15B16(I)";
        messages.connectedTag20 = "Tag Released";
      }
      if (tag16 && tag16.includes("B15B16")) {
        updatedTags.connectedTag16 = "1B15B16(I)";
        messages.connectedTag16 = "Tag Released";
      }
    }

    // Force release logic for 1B25B16
    if (input === "1B25B16-1B25B16-0") {
      if (tag19 && tag19.includes("B25B16")) {
        updatedTags.connectedTag19 = "1B25B16(I)";
        messages.connectedTag19 = "Tag Released";
      }
      if (tag20 && tag20.includes("B25B16")) {
        updatedTags.connectedTag20 = "1B25B16(I)";
        messages.connectedTag20 = "Tag Released";
      }
      if (tag25 && tag25.includes("B25B16")) {
        updatedTags.connectedTag25 = "1B25B16(I)";
        messages.connectedTag25 = "Tag Released";
      }

      // Ensure tag16 is not updated for 1B25B16 flow
      delete updatedTags.connectedTag16;
      delete messages.connectedTag16;
    }

    // Set individual connectedTag states
    setUpdatedConnectedTags(updatedTags);
    if (updatedTags.connectedTag19) setConnectedTag19(updatedTags.connectedTag19);
    if (updatedTags.connectedTag20) setConnectedTag20(updatedTags.connectedTag20);
    if (updatedTags.connectedTag16) setConnectedTag16(updatedTags.connectedTag16);
    if (updatedTags.connectedTag15) setConnectedTag15(updatedTags.connectedTag15);
    if (updatedTags.connectedTag25) setConnectedTag25(updatedTags.connectedTag25);

    // Merge into cumulative tag-release state
    setAllReleasedTags((prev) => ({
      ...prev,
      ...messages,
    }));

    setReleaseMessages((prev) => ({
      ...prev,
      ...messages,
    }));
  };


  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogout = () => {
    // Clear login status from localStorage
    localStorage.removeItem("isLoggedIn");

    // Notify other tabs about logout
    localStorage.setItem("logout-event", Date.now());

    // Redirect to LoginPage (forces reload in all tabs)
    window.location.href = "/";
  };


  const formatNumberWithCommas = (value) => {
    // Remove all non-numeric characters (to handle user input correctly)
    value = value.replace(/[^0-9]/g, "");

    // First handle Indian number system for lakh, crore, etc.
    if (value.length > 3) {
      let lastThree = value.slice(-3); // Get the last three digits
      let otherNumbers = value.slice(0, value.length - 3); // Get the rest of the number

      // Format the first part using comma every two digits
      otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

      // Join the formatted parts
      return otherNumbers + "," + lastThree;
    }

    // If the number is less than 1000, just return the value (without commas)
    return value;
  };

  // Function to remove commas from a formatted number
  const removeCommas = (value) => {
    return value.replace(/,/g, "");
  };

  const handleAmountChange = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount(formattedValue);
  };
  const handleAmountChange15 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount1("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount1(formattedValue);
  };
  const handleAmountChange15to17 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount2("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount2(formattedValue);
  };
  const handleAmountChange15to18 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount3("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount3(formattedValue);
  };
  const handleAmountChange16to19 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount4("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount4(formattedValue);
  };
  const handleAmountChange16to20 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount5("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount5(formattedValue);
  };
  const handleAmountChange25to16 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount25("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount25(formattedValue);
  };
  const handleAmountChange17to21 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount6("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount6(formattedValue);
  };
  const handleAmountChange17to22 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount7("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount7(formattedValue);
  };
  const handleAmountChange18to23 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount8("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount8(formattedValue);
  };
  const handleAmountChange18to24 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount9("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount9(formattedValue);
  };

  const handleTransfer = async () => {
    if (!amount) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi(amount);

      setTag4(data.tag4);
      setTag15(data.tag15); // Set tag5 from the API response
      setConnectedTag15(data.connectedTag15);

      setAmountTransferred15(data.amountTransferred15);
      setIsTransactionSuccessful(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer15to16 = async () => {
    if (!amount1) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi15to16(amount1);

      // Retain the old tag5 data and only set tag6 from the API response

      if (data.tag16 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      setTag16(data.tag16); // Set tag6 from the API response
      setConnectedTag16(data.connectedTag16);
      setAmountTransferred16(data.amountTransferred16);
      setIsTransactionSuccessful15(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer15to17 = async () => {
    if (!amount2) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi15to17(amount2);
      if (data.tag17 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag17(data.tag17); // Set tag6 from the API response

      setAmountTransferred17(data.amountTransferred17);
      setIsTransactionSuccessful15to17(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer15to18 = async () => {
    if (!amount3) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi15to18(amount3);
      if (data.tag18 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag18(data.tag18); // Set tag6 from the API response

      setAmountTransferred18(data.amountTransferred18);
      setIsTransactionSuccessful15to18(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer16to19 = async () => {
    if (!amount4) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi16to19(amount4);
      if (data.tag19 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag19(data.tag19); // Set tag6 from the API response
      setAmountTransferred19(data.amountTransferred19);
      setConnectedTag19(data.connectedTag19);
      setIsTransactionSuccessful16to19(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer16to20 = async () => {
    if (!amount5) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi16to20(amount5);
      if (data.tag20 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag20(data.tag20); // Set tag6 from the API response
      setConnectedTag20(data.connectedTag20);
      setAmountTransferred20(data.amountTransferred20);
      setIsTransactionSuccessful16to20(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer17to21 = async () => {
    if (!amount6) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi17to21(amount6);
      if (data.tag21 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag21(data.tag21); // Set tag6 from the API response
      setConnectedTag21(data.connectedTag21);
      setAmountTransferred21(data.amountTransferred21);
      setIsTransactionSuccessful17to21(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer17to22 = async () => {
    if (!amount7) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi17to22(amount7);
      if (data.tag22 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }
      // Retain the old tag5 data and only set tag6 from the API response
      setTag22(data.tag22); // Set tag6 from the API response
      setConnectedTag22(data.connectedTag22);
      setAmountTransferred22(data.amountTransferred22);
      setIsTransactionSuccessful17to22(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer18to23 = async () => {
    if (!amount8) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi18to23(amount8);
      if (data.tag23 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag23(data.tag23); // Set tag6 from the API response
      setConnectedTag23(data.connectedTag23);
      setAmountTransferred23(data.amountTransferred23);
      setIsTransactionSuccessful18to23(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer18to24 = async () => {
    if (!amount9) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi18to24(amount9);
      if (data.tag24 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag24(data.tag24); // Set tag6 from the API response
      setConnectedTag24(data.connectedTag24);
      setAmountTransferred24(data.amountTransferred24);
      setIsTransactionSuccessful18to24(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer25to16 = async () => {
    if (!amount25) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi25to16(amount25);

      // Retain the old tag5 data and only set tag6 from the API response

      if (data.tag25 == "1B15B16") {
        setPanicMessage("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      setTag25(data.tag25); // Set tag6 from the API response
      setConnectedTag25(data.connectedTag25);
      setAmountTransferred25(data.amountTransferred25);
      setIsTransactionSuccessful25to16(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handlePanicButtonClick = async () => {
    try {
      setPanicMessage(null);

      const part1Value = "1B15B16";

      const tags = [
        tag16,
        tag17,
        tag18,
        tag19,
        tag20,
        tag21,
        tag22,
        tag23,
        tag24,
        tag25,
      ]; // All tags

      const data = await markFraud(part1Value, tags); // Use the API function

      if (data.message) {
        setPanicMessage(data.message);
      } else {
        setPanicMessage(null); // Clear any previous panic message if no matching tag found
      }
    } catch (error) {
      console.error("Error occurred while calling API:", error);
      setPanicMessage(null); // Clear any previous panic message if an error occurs
    }
  };
  // Usage example for truncate operation
  const handleTruncate = async () => {
    setLoading(true); // Show loader
    try {
      const status = await handleTruncateApi();
      setStatus(status);
      setTimeout(() => setStatus(null), 1000);
      setTagValidity(0); // Reset Tag Validity to 0
    } catch (error) {
      console.error("Error during truncate operation:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  // Usage example for insert operation
  const handleInsert = async () => {
    setLoading1(true); // Show loader
    try {
      const status1 = await handleInsertApi();
      setStatus1(status1);
      setTimeout(() => setStatus1(null), 1000);
    } catch (error) {
      console.error("Error during insert operation:", error);
    } finally {
      setLoading1(false); // Hide loader
    }
  };

  return (
    <>
      <h1 className="main-title">
        Release Tag
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </h1>
      <div className="bank-wrapper1">
        {/* Horizontal Container for Bank 4 and Bank 5 */}

        <div className="horizontal-bank-container">
          <div className="bank-container bank51-container">
            <div className="bank-label15">Bank 15</div> {/* Bank label */}
            <div className="tag-label12">Tager code B15</div>
            {/*  Bank transfer 5 to 6 */}
            {isTransactionSuccessful15 ? (
              <div className="transaction-success-message5to61">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount1 ? "prefilled" : ""}`}
                  value={amount1}
                  onChange={handleAmountChange15}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer15to16(); // Your transfer logic
                    setIsTransactionSuccessful15(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/*  Bank transfer 5 to 7 */}
            {/* Dotted divider between 5 to 6 and 5 to 7 */}
            <div className="dotted-divider5to6"></div>
            {isTransactionSuccessful15to17 ? (
              <div className="transaction-success-message5to7">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount2 ? "prefilled" : ""}`}
                  value={amount2}
                  onChange={handleAmountChange15to17}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer15to17(); // Your transfer logic
                    setIsTransactionSuccessful15to17(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/*  Bank transfer 5 to 8 */}
            <div className="dotted-divider5to6"></div>
            {isTransactionSuccessful15to18 ? (
              <div className="transaction-success-message5to8">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount3 ? "prefilled" : ""}`}
                  value={amount3}
                  onChange={handleAmountChange15to18}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button81"
                  onClick={() => {
                    handleTransfer15to18(); // Your transfer logic
                    setIsTransactionSuccessful15to18(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            <div className="tag-amount-container">
              {tag15 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag15.split("-")[0] === "1B15B16" && (
                    <div className="panic-message15">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {connectedTag15 &&
                    connectedTag15.split(",").some((tag) => {
                      const isTagReleased =
                        (tag15.split("-")[0] === "1B15B16" &&
                          tag.trim() === "1B15B16(I)") ||
                        (tag15.split("-")[0] === "1B25B16" &&
                          tag.trim() === "1B25B16(I)");
                      return isTagReleased;
                    }) && <div className="panic-message163">Tag Released</div>}

                  <div className="tag-response">
                    {" "}
                    <span
                      style={{
                        textDecoration:
                          connectedTag15 &&
                            connectedTag15.split(",").some((tag) => {
                              console.log(tag.trim(), "15"); // Check what each tag looks like
                              return tag.trim().includes("(I)");
                            })
                            ? "line-through"
                            : "none",
                      }}>
                      {tag15}
                    </span>
                  </div>

                  <div className="tag-response">{tag15}</div>
                  {amountTransferred15 && (
                    <div className="amount-transferred5">
                      ₹ {formatNumberWithCommas(amountTransferred15.toString())}
                    </div>
                  )}
                </div>
              )}

              {tag16 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag18.split("-")[0] === "1B15B16" && (
                    <div className="panic-message166">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {connectedTag16 &&
                    connectedTag16.split(",").some((tag) => {
                      const isTagReleased =
                        (tag16.split("-")[0] === "1B15B16" &&
                          tag.trim() === "1B15B16(I)") ||
                        (tag16.split("-")[0] === "1B25B16" &&
                          tag.trim() === "1B25B16(I)");
                      return isTagReleased;
                    }) && <div className="panic-message173">Tag Released</div>}
                  <div className="tag16new-response">
                    <span
                      style={{
                        // Apply strike-through if releaseMessages has "Tag Released" for connectedTag15
                        textDecoration: connectedTag15
                          .split(",")
                          .some((tag) => {
                            return (
                              tag.trim() === "1B15B16(I)" ||
                              tag.trim() === "1B25B16(I)"
                            );
                            console.log(tag.trim(), "16");
                          })
                          ? "line-through"
                          : "none",
                      }}>
                      {tag16}
                    </span>
                  </div>
                  {amountTransferred16 && (
                    <div className="amount-transferred16new">
                      ₹ {formatNumberWithCommas(amountTransferred16.toString())}
                    </div>
                  )}
                </div>
              )}

              {tag17 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag17.split("-")[0] === "1B15B16" && (
                    <div className="panic-message17">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  <div className="tag7new-response">{tag17}</div>
                  {amountTransferred17 && (
                    <div className="amount-transferred7new">
                      ₹ {formatNumberWithCommas(amountTransferred17.toString())}
                    </div>
                  )}
                </div>
              )}

              {tag18 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag16.split("-")[0] === "1B15B16" && (
                    <div className="panic-message18">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  <div className="tag8-response">{tag18}</div>
                  {amountTransferred18 && (
                    <div className="amount-transferred8">
                      ₹ {formatNumberWithCommas(amountTransferred18.toString())}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="tag-responses-container">
              {/* Tag 9 */}
              {tag19 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag19.split("-")[0] === "1B15B16" && (
                    <div className="panic-message19a">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {connectedTag19 &&
                    connectedTag19.split(",").some((connectedTag) => {
                      const extractedTag = tag19.split("-")[0]; // Extract the first part of the tag
                      const isTag15Valid =
                        extractedTag === "1B15B16" &&
                        connectedTag.trim() === "1B15B16(I)";
                      const isTag25Valid =
                        extractedTag === "1B25B16" &&
                        connectedTag.trim() === "1B25B16(I)";
                      return isTag15Valid || isTag25Valid;
                    }) && <div className="panic-message19a">Tag Released</div>}
                  <div className="tag-response tag9-response">
                    {" "}
                    <span
                      style={{
                        textDecoration:
                          connectedTag19 &&
                            connectedTag19.split(",").some((connectedTag) => {
                              const extractedTag = tag19.split("-")[0]; // Extract the first part of the tag
                              console.log("Extracted tag:", extractedTag);
                              console.log(
                                "Checking connectedTag19:",
                                connectedTag.trim()
                              );

                              // Validation conditions
                              const isTag15Valid =
                                extractedTag === "1B15B16" &&
                                connectedTag.trim() === "1B15B16(I)";
                              const isTag25Valid =
                                extractedTag === "1B25B16" &&
                                connectedTag.trim() === "1B25B16(I)";

                              return isTag15Valid || isTag25Valid;
                            })
                            ? "line-through"
                            : "none",
                      }}>
                      {tag19}
                    </span>
                  </div>
                  {amountTransferred19 && (
                    <div className="amount-transferred9">
                      ₹ {formatNumberWithCommas(amountTransferred19.toString())}
                    </div>
                  )}
                </div>
              )}

              {/* Tag 10 */}
              {tag20 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag20.split("-")[0] === "1B15B16" && (
                    <div className="panic-message20">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {connectedTag20 &&
                    connectedTag20.split(",").some((connectedTag) => {
                      const extractedTag = tag20.split("-")[0]; // Extract the first part of the tag
                      const isTag15Valid =
                        extractedTag === "1B15B16" &&
                        connectedTag.trim() === "1B15B16(I)";
                      const isTag25Valid =
                        extractedTag === "1B25B16" &&
                        connectedTag.trim() === "1B25B16(I)";
                      return isTag15Valid || isTag25Valid;
                    }) && <div className="panic-message20">Tag Released</div>}
                  <div className="tag-response tag104-response">
                    {" "}
                    <span
                      style={{
                        textDecoration:
                          connectedTag20 &&
                            connectedTag20.split(",").some((connectedTag) => {
                              const extractedTag = tag20.split("-")[0]; // Extract the first part of the tag
                              console.log("Extracted tag:", extractedTag);
                              console.log(
                                "Checking connectedTag20:",
                                connectedTag.trim()
                              );

                              // Validation conditions
                              const isTag15Valid =
                                extractedTag === "1B15B16" &&
                                connectedTag.trim() === "1B15B16(I)";
                              const isTag25Valid =
                                extractedTag === "1B25B16" &&
                                connectedTag.trim() === "1B25B16(I)";

                              return isTag15Valid || isTag25Valid;
                            })
                            ? "line-through"
                            : "none",
                      }}>
                      {tag20}
                    </span>
                  </div>
                  {amountTransferred20 && (
                    <div className="amount-transferred10">
                      ₹ {formatNumberWithCommas(amountTransferred20.toString())}
                    </div>
                  )}
                </div>
              )}

              {/* Tag 11 */}
              {tag21 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag21.split("-")[0] === "1B15B16" && (
                    <div className="panic-message21">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  <div className="tag-response tag11-response">{tag21}</div>
                  {amountTransferred21 && (
                    <div className="amount-transferred11">
                      ₹ {formatNumberWithCommas(amountTransferred21.toString())}
                    </div>
                  )}
                </div>
              )}

              {/* Tag 12 */}
              {tag22 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag22.split("-")[0] === "1B15B16" && (
                    <div className="panic-message8">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  <div className="tag-response tag12-response">{tag22}</div>
                  {amountTransferred22 && (
                    <div className="amount-transferred12">
                      ₹ {formatNumberWithCommas(amountTransferred22.toString())}
                    </div>
                  )}
                </div>
              )}
              {/* Tag 12 */}
              {tag23 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag23.split("-")[0] === "1B15B16" && (
                    <div className="panic-message9">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  <div className="tag-response tag13-response">{tag23}</div>
                  {amountTransferred23 && (
                    <div className="amount-transferred13">
                      ₹ {formatNumberWithCommas(amountTransferred23.toString())}
                    </div>
                  )}
                </div>
              )}
              {tag24 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag24.split("-")[0] === "1B15B16" && (
                    <div className="panic-message10">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  <div className="tag-response tag14-response">{tag24}</div>
                  {amountTransferred24 && (
                    <div className="amount-transferred14">
                      ₹ {formatNumberWithCommas(amountTransferred24.toString())}
                    </div>
                  )}
                </div>
              )}
              {tag25 && (
                <div className="tag-response-wrapper">
                  {panicMessage && tag25.split("-")[0] === "1B15B16" && (
                    <div className="panic-message25">
                      {panicMessage}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {connectedTag25 &&
                    connectedTag25.split(",").some((tag) => {
                      const isTagReleased =
                        (tag25.split("-")[0] === "1B15B16" &&
                          tag.trim() === "1B15B16(I)") ||
                        (tag25.split("-")[0] === "1B25B16" &&
                          tag.trim() === "1B25B16(I)");
                      return isTagReleased;
                    }) && <div className="panic-message174">Tag Released</div>}
                  <div className="tag-response tag25-response">
                    {" "}
                    <span
                      style={{
                        textDecoration:
                          connectedTag25 &&
                            connectedTag25.split(",").some((tag) => {
                              console.log(tag.trim(), "25"); // Check what each tag looks like
                              return tag.trim().includes("(I)");
                            })
                            ? "line-through"
                            : "none",
                      }}>
                      {tag25}
                    </span>
                  </div>
                  {amountTransferred25 && (
                    <div className="amount-transferred25">
                      ₹ {formatNumberWithCommas(amountTransferred25.toString())}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="bank255-container">
              <div className="bank-label25">Bank 25</div> {/* Bank label */}
              <div className="tag-label25">Tager code 25</div>
              {isTransactionSuccessful25to16 ? (
                <div className="transaction-success-message6to9">
                  Transaction successful!
                </div>
              ) : (
                <div className="amount-containernew">
                  <input
                    type="text"
                    className={`amount-input ${amount25 ? "prefilled" : ""}`}
                    value={amount25}
                    onChange={handleAmountChange25to16}
                    style={{
                      width: "95px",
                      padding: "5px",
                      fontSize: "14px",
                      position: "relative",
                      top: "15px",
                      paddingLeft: "20px",
                      left: "5px",
                      fontWeight: "bold", // Make the text bold
                    }}
                  />

                  <button
                    className="transfer-button"
                    onClick={() => {
                      handleTransfer25to16(); // Your transfer logic
                      setIsTransactionSuccessful25to16(true); // Set transaction success to true
                    }}>
                    Transfer
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* Add the arrows */}
          <div className="arrow-container">
            <div className="arrow-to-bank16">&#8594;</div>
            <div className="arrow-to-bank17">&#8594;</div>
            <div className="arrow-to-bank18">&#8594;</div>
            <div className="arrow-to-bank25">&#8594;</div>
          </div>
        </div>

        {/* Vertical Bank Containers */}
        <div className="vertical-bank-container">
          <div className="vertical-bank-item">
            <div className="bank-label16">NBFC 16</div>{" "}
            {/* Added Bank label here */}
            <div className="tag-label13">Tager code B16</div>
            {/* Bank transfer 6 to 9 */}
            {isTransactionSuccessful16to19 ? (
              <div className="transaction-success-message6to9">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount4 ? "prefilled" : ""}`}
                  value={amount4}
                  onChange={handleAmountChange16to19}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer16to19(); // Your transfer logic
                    setIsTransactionSuccessful16to19(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/* Bank transfer 6 to 10 */}
            <div className="dotted-divider2"></div>
            {isTransactionSuccessful16to20 ? (
              <div className="transaction-success-message6to10">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount5 ? "prefilled" : ""}`}
                  value={amount5}
                  onChange={handleAmountChange16to20}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button6"
                  onClick={() => {
                    handleTransfer16to20(); // Your transfer logic
                    setIsTransactionSuccessful16to20(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
          </div>
          {/* Bank transfer 7 to 11 */}

          <div className="vertical-bank-item">
            <div className="bank-label17">Bank 17</div>{" "}
            {/* Added Bank label here */}
            {/* Bank 7 Container with Amount Input */}
            <div className="tag-label14">Tager code B17</div>
            {isTransactionSuccessful17to21 ? (
              <div className="transaction-success-message7to11">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount6 ? "prefilled" : ""}`}
                  value={amount6}
                  onChange={handleAmountChange17to21}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer17to21(); // Your transfer logic
                    setIsTransactionSuccessful17to21(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            <div className="dotted-divider2"></div>
            {/* Bank transfer 7 to 12 */}
            {isTransactionSuccessful17to22 ? (
              <div className="transaction-success-message7to12">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount7 ? "prefilled" : ""}`}
                  value={amount7}
                  onChange={handleAmountChange17to22}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />
                <button
                  className="transfer-button7"
                  onClick={() => {
                    handleTransfer17to22(); // Your transfer logic
                    setIsTransactionSuccessful17to22(true); // Mark transaction as successful
                  }}>
                  Transfer
                </button>
              </div>
            )}
          </div>
          {/* Bank transfer 8 to 13 */}

          <div className="vertical-bank-item">
            <div className="bank-label18">Bank 18</div>{" "}
            {/* Added Bank label here */}
            <div className="tag-label15">Tager code B18</div>
            {isTransactionSuccessful18to23 ? (
              <div className="transaction-success-message8to13">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount8 ? "prefilled" : ""}`}
                  value={amount8}
                  onChange={handleAmountChange18to23}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer18to23(); // Your transfer logic
                    setIsTransactionSuccessful18to23(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/* Bank transfer 8 to 14 */}
            <div className="dotted-divider2"></div>
            {/* Amount Container for Bank 8 to 14 */}
            {isTransactionSuccessful18to24 ? (
              <div className="transaction-success-message8to14">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount9 ? "prefilled" : ""}`}
                  value={amount9}
                  onChange={handleAmountChange18to24}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button8"
                  onClick={() => {
                    handleTransfer18to24(); // Your transfer logic
                    setIsTransactionSuccessful18to24(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/* Panic Button */}
            {/* Panic Button */}
            <div className="button-container">
              <button
                className={`circle-button ${status === "success" ? "green" : "red"
                  }`}
                onClick={handleTruncate}
                disabled={loading} // Disable button while loading
              >
                {loading ? (
                  <span className="loader">...</span> // Show loader
                ) : status === "success" ? (
                  <FaCheckCircle />
                ) : null}{" "}
                {/* Show nothing if no status or loading */}
              </button>

              <button
                className={`circle-button2 ${status1 === "success" ? "green" : "red"
                  }`}
                onClick={handleInsert}
                disabled={loading1} // Disable button while loading
              >
                {loading1 ? (
                  <span className="loader">...</span> // Show loader
                ) : status1 === "success" ? (
                  <FaCheckCircle />
                ) : null}{" "}
                {/* Show nothing if no status or loading */}
              </button>
            </div>
            <div className="buttonrelease-container">
              {/* <p
                style={{
                  marginBottom: "-80px",
                  display: "block",
                  marginLeft: "-130px",
                }}>
                Select Tag:
              </p> */}

              <select
                id="dropdown"
                value={selectedOption}
                onChange={handleDropdownChange}
                style={{
                  width: "160px", // Adjust width
                  height: "40px", // Adjust height
                  fontSize: "14px",
                  marginLeft: "-10px",
                  padding: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  marginTop: "70px",
                }}>
                <option value="">Select Tag</option>
                <option value="1B15B16-1B15B16-0">1B15B16-1B15B16-0</option>
                <option value="1B25B16-1B25B16-0">1B25B16-1B25B16-0</option>
              </select>
              <button
                onClick={() => {
                  console.log("Release button clicked"); // Debug log
                  handleReleaseButtonClick();
                }}
                style={{
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#007BFF",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  marginLeft: "-45px",
                  fontSize: "14px",
                  cursor: "pointer",
                  marginBottom: "-30px",
                }}>
                Release
              </button>
            </div>
            {/* <div className="fund-movement-container">
              <div className="fund-movement">
                Fund Movement :
                <span className="red-value">
                  {count !== null ? count : "Loading..."}
                </span>
              </div>
              <div className="time-taken1">
                Time Taken:{" "}
                <span className="red-value">
                  {timeDifference !== null
                    ? `${timeDifference} `
                    : "Loading..."}
                </span>
              </div>
              <div className="withdrawal-count">
                Withdrawal Attempts: <span className="red-value">0</span>
              </div>
              <div className="tag-validity">
                Tag Validity:
                <span className="red-value">
                  {tagvalidity !== null ? `${tagvalidity}` : "0"}
                </span>
              </div>
            </div> */}
          </div>
        </div>

        <div className="arrow-containernew">
          <div className="arrow-to-bank19">&#8594;</div>
          <div className="arrow-to-bank20">&#8594;</div>

          <div className="arrow-to-bank21"> &#8594;</div>
          <div className="arrow-to-bank22">&#8594;</div>

          <div className="arrow-to-bank23">&#8594;</div>
          <div className="arrow-to-bank24">&#8594;</div>
        </div>

        <div className="vertical-bank-container2">
          <div className="vertical-bank-item3">
            {/* Bank 9 Label */}
            <div className="bank-label19">Bank 19</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label16">Tager code B19</div>
            {isTransactionSuccessful16to19 && (
              <div className="tick-iconnew">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 10 Label */}
            <div className="bank-label20">Bank 20</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label17">Tager code B20</div>
            {isTransactionSuccessful16to20 && (
              <div className="tick-iconnew">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 11 Label */}
            <div className="bank-label21">Bank 21</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label18">Tager code B21</div>
            {isTransactionSuccessful17to21 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 11 Label */}
            <div className="bank-label22">Bank 22</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label19">Tager code B22</div>
            {isTransactionSuccessful17to22 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 11 Label */}
            <div className="bank-label23">Bank 23</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label20">Tager code B23</div>
            {isTransactionSuccessful18to23 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 14 Label */}
            <div className="bank-label24">Bank 24</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label21">Tager code B24</div>
            {isTransactionSuccessful18to24 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
        </div>
        <div className="vertical-bank-container2">
          {(connectedTag19 ||
            connectedTag20 ||
            connectedTag21 ||
            connectedTag22 ||
            connectedTag23 ||
            connectedTag24) && (
              <h3 className="connected-tag-title">Connected Tag</h3>
            )}

          {connectedTag19 && (
            <div className="connected-tag19">
              <div className="tag1619new-response">
                {connectedTag19.split(",").map((tag, index) => (
                  <React.Fragment key={index}>
                    <span
                      style={{
                        textDecoration: tag.includes("(I)")
                          ? "line-through"
                          : "none",
                      }}>
                      {tag.trim()}
                    </span>
                    {index < connectedTag19.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          {connectedTag20 && (
            <div className="connected-tag20">
              <div className="tag1619new-response">
                {connectedTag20.split(",").map((tag, index) => (
                  <React.Fragment key={index}>
                    <span
                      style={{
                        textDecoration: tag.includes("(I)")
                          ? "line-through"
                          : "none",
                      }}>
                      {tag.trim()}
                    </span>
                    {index < connectedTag20.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          {connectedTag21 && (
            <div className="connected-tag21">
              <div className="tag1619new-response">
                {connectedTag21.split(",").map((tag, index) => (
                  <React.Fragment key={index}>
                    {tag.trim()}
                    {index < connectedTag21.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          {connectedTag22 && (
            <div className="connected-tag22">
              <div className="tag1619new-response">
                {connectedTag22.split(",").map((tag, index) => (
                  <React.Fragment key={index}>
                    {tag.trim()}
                    {index < connectedTag22.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          {connectedTag23 && (
            <div className="connected-tag23">
              <div className="tag1619new-response">
                {connectedTag23.split(",").map((tag, index) => (
                  <React.Fragment key={index}>
                    {tag.trim()}
                    {index < connectedTag23.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          {connectedTag24 && (
            <div className="connected-tag24">
              <div className="tag1619new-response">
                {connectedTag24.split(",").map((tag, index) => (
                  <React.Fragment key={index}>
                    {tag.trim()}
                    {index < connectedTag24.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BankTransfer15to25;